/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

/* Internal Imports */
/* Components */

/**
 *
 * @returns
 */
const IframeForm = ({ sectionContent }) => {
  const [deviceWidth, setDeviceWidth] = useState(0);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        setDeviceWidth(window.innerWidth);
      };

      handleResize(); // Set initial width
      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);
  return (
    <>
      <Flex
        justify="center"
        pos="relative"
        top={{ base: '-5vh', md: '-5vh', lg: '-15.6vh' }}
      >
        <Box
          borderRadius="1rem"
          width={{ base: '100%', lg: '70vw' }}
          boxShadow="0px 0px 2px 4px rgba(0,0,0,0.1)"
          bg="#f7f7f7"
        >
          <Box
            // py={{ base: '0px', md: '0',lg:"34px" }}
            pt={{ base: '20px', md: '20px', lg: '34px' }}
            fontSize={{ base: '30px', md: '40px', lg: '50px' }}
            fontWeight="500"
            textAlign="center"
            fontFamily="var(--FedraSansStdAMedium)"
          >
            {sectionContent[0].text}
          </Box>
          <Box
            as="iframe"
            width={{ base: '100%', md: '100%', lg: '100%' }}
            minH={{ base: '500px', lg: '1900px' }}
            scrolling={deviceWidth < 768 ? 'yes' : 'no'}
            //  minH={{ base: '1440px', md: '1400px', lg: '1450px', xl: '1500px', '2xl': '1800px' }}
            h="auto"
            overflow="auto"
            src={sectionContent[1].linkUrl}
          ></Box>
        </Box>
      </Flex>
    </>
  );
};

export default IframeForm;
